(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-embroidery"]) return;
  try {
    
const root = document.querySelector('#home-embroidery');

if (root && root.dataset.collectionUrl) {
  const collectionUrl = root.dataset.collectionUrl;

  const mountCollection = async () => {
    const response = await fetch(collectionUrl);
    if (!response.ok) return;
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    if (doc.querySelector('form[action*="/password"]')) return;

    const main = doc.querySelector('#MainContent');
    if (!main) return;

    const sections = [...main.children].filter(
      (node) => node.classList && node.classList.contains('shopify-section')
    );
    if (!sections.length) return;

    const title = doc.querySelector('title');
    if (title && title.textContent) {
      document.title = title.textContent.trim();
    }

    root.replaceChildren();
    sections.forEach((section) => {
      section.querySelectorAll('script').forEach((script) => script.remove());
      root.appendChild(document.importNode(section, true));
    });

    const mainSection = root.querySelector('.shopify-section[id$="__main"]');
    const grid = mainSection && mainSection.querySelector('ul.product-grid');
    if (!mainSection || !grid) return;

    const sectionKey = mainSection.id.replace('shopify-section-', '');
    const seen = new Set(
      [...grid.querySelectorAll('li.product-grid__item')].map((item) => item.dataset.productId)
    );

    for (let page = 2; page <= 8; page += 1) {
      const pageUrl = new URL(collectionUrl, window.location.origin);
      pageUrl.searchParams.set('page', String(page));
      pageUrl.searchParams.set('sections', sectionKey);
      const pageResponse = await fetch(pageUrl);
      if (!pageResponse.ok) break;
      const pageJson = await pageResponse.json();
      const pageHtml = pageJson[sectionKey];
      if (!pageHtml) break;

      const pageDoc = new DOMParser().parseFromString(pageHtml, 'text/html');
      const fresh = [...pageDoc.querySelectorAll('li.product-grid__item')].filter((item) => {
        const id = item.dataset.productId;
        if (!id || seen.has(id)) return false;
        seen.add(id);
        return true;
      });
      if (!fresh.length) break;
      fresh.forEach((item) => grid.appendChild(document.importNode(item, true)));
    }
  };

  root.addEventListener('change', (event) => {
    const field = event.target;
    if (!field || !field.name) return;
    if (field.name !== 'sort_by' && !String(field.name).startsWith('filter.')) return;
    const form = field.form;
    if (!form) return;
    const url = new URL(collectionUrl, window.location.origin);
    url.search = new URLSearchParams(new FormData(form)).toString();
    window.location.assign(url.toString());
  });

  mountCollection();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
